
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as datagQ7BEH5Mmohhb48fLupxerZT2Gi3CuXXW0t3zLQlTSQMeta } from "/vercel/path0/src/pages/data.vue?macro=true";
import { default as aboutnkAkLFijnv8sMkMYpnQubcB4xweqAdqK4rrhQJe7am4Meta } from "/vercel/path0/src/pages/about.vue?macro=true";
import { default as indexjXfg20vSWiqV3Wel4ayAAWoFt0maAgUV4XGStNqb8sIMeta } from "/vercel/path0/src/pages/index.vue?macro=true";
import { default as playgroundGK1CyFsfOYg7IRNU7qh2lR21WJG4LFgFWJHxlAcpgfYMeta } from "/vercel/path0/src/pages/playground.vue?macro=true";
import { default as methodologyHH29hdxYJAYquTQahxCDLs88k93yoSu1ZnjfWJIzWO8Meta } from "/vercel/path0/src/pages/methodology.vue?macro=true";
import { default as indextq5YbT_JRdup_2ZEfZo_Lg4PNYtFHfU7CBcKmgrZMv4Meta } from "/vercel/path0/src/pages/analysis/index.vue?macro=true";
import { default as _91slug_93zqEQa7hlFwsMpYFxQfJ5TObOsLys5_45U5h5rpS7nf8V0Meta } from "/vercel/path0/src/pages/analysis/[slug].vue?macro=true";
import { default as why_45methane_45mattersHAq_45jR2S3t01j4dIa8YMn7dLyfUkdQ7PYutk4FDTxUsMeta } from "/vercel/path0/src/pages/why-methane-matters.vue?macro=true";
import { default as _91_91target_93_93QRMAmvG987bucE3CIh2btNUn10ssopSyIpR2LLMgrM0Meta } from "/vercel/path0/src/pages/map/[[targetType]]/[[target]].vue?macro=true";
export default [
  {
    name: "data",
    path: "/data",
    component: () => import("/vercel/path0/src/pages/data.vue")
  },
  {
    name: "about",
    path: "/about",
    component: () => import("/vercel/path0/src/pages/about.vue")
  },
  {
    name: "index",
    path: "/",
    component: () => import("/vercel/path0/src/pages/index.vue")
  },
  {
    name: "playground",
    path: "/playground",
    component: () => import("/vercel/path0/src/pages/playground.vue")
  },
  {
    name: "methodology",
    path: "/methodology",
    component: () => import("/vercel/path0/src/pages/methodology.vue")
  },
  {
    name: "analysis",
    path: "/analysis",
    component: () => import("/vercel/path0/src/pages/analysis/index.vue")
  },
  {
    name: "analysis-slug",
    path: "/analysis/:slug()",
    component: () => import("/vercel/path0/src/pages/analysis/[slug].vue")
  },
  {
    name: "why-methane-matters",
    path: "/why-methane-matters",
    component: () => import("/vercel/path0/src/pages/why-methane-matters.vue")
  },
  {
    name: "map-targetType-target",
    path: "/map/:targetType?/:target?",
    meta: _91_91target_93_93QRMAmvG987bucE3CIh2btNUn10ssopSyIpR2LLMgrM0Meta || {},
    component: () => import("/vercel/path0/src/pages/map/[[targetType]]/[[target]].vue")
  }
]